export default "<div class=\"requests-container\"></div>\n";